// extracted by mini-css-extract-plugin
export default {"about":"Footer_about__+3f9V","projects":"Footer_projects__plZWP","footer":"Footer_footer__PxxIj","container":"Footer_container__iICw7"};